import { render, staticRenderFns } from "./PokemonAdd.vue?vue&type=template&id=006ec2dc&scoped=true"
import script from "./PokemonAdd.vue?vue&type=script&lang=js"
export * from "./PokemonAdd.vue?vue&type=script&lang=js"
import style0 from "./PokemonAdd.vue?vue&type=style&index=0&id=006ec2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ec2dc",
  null
  
)

export default component.exports